export default "__VITE_ASSET__CnLxcGZU__"